import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ZoomTable from '../../commons/zoomTable/zoomTable';
import {
  tabViewList,
  bulkActionsDropdown,
  areAllRowsSelected
} from './ceTaskboardHelper';
import { setPageName } from '../../../services/pageService/pageActionCreator';

import ConfirmationModal from '../../commons/confirmationModal/confirmationModal';
import {
  getTaskboardData,
  updatePageNumber,
  changeTaskStatus,
  markUnmarkDacc,
  scheduleTask,
  updateConsignmentAppointmentData,
  updateFilter,
  bulkUploadAppointment,
  getPoDetailsByConsignmentId,
  getFcNameHash,
  approveHolidayDeliveryRequest,
  rejectHolidayDeliveryRequest,
  updateTaskBoardTable,
  bulkApproveOrReject,
  getConsignmentAppointmentSummary,
  getConsignmentAppointmentDetails,
  downloadStatusReport
} from './ceTaskboardRedux/ceTaskboardActionCreator';
import {
  deliveryTypeStatusMap,
  deliveryTypeFilterStatusList,
  isAppointmentDelivery
} from '../../helper/DeliveryTypeHelper';
import DaccModal from './daccModal';
import RejectHolidayDeliveryRequestModal from './rejectHolidayDeliveryRequestModal';
import CreateNewAppointmentTaskModal from './createNewAppointmentTaskModal';
import BulkUploadModal from './bulkUploadModal';
import DownloadReportModal from './downloadReportModal';
import TabView from '../../commons/tabView/tabView';
import styles from './ceTaskboard.scss';
import SearchBox from '../../commons/searchBox/searchBox';
import Select from '../../commons/formElements/select/select';
import ModalWithTable from '../../commons/modalWithTable/modalWithTable';
import ClientSearch from '../../commons/clientSearch';
import { toastr } from 'react-redux-toastr';
import moment from 'moment';
import DateRangeFilter from '../../commons/dateFilter/dateFilter';
import { defaultPODetail } from '../../helper/PurchaseOrderHelper';

const pageObj = {
  pageName: 'CE TASKBOARD',
  betaPage: false
};

const initialStatusFilterValue = { key: 'PENDNG', val: 'PENDING' };

class CETaskboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowData: {},
      isDaccModalVisible: false,
      isCreateNewTaskModalVisible: false,
      isBulkUploadModalVisible: false,
      isPoDetailsModalVisible: false,
      isDownloadReportModalVisible: false,
      rowButtonDisabledById: -1,
      isRejectHolidayDeliveryModalVisible: false,
      holidayDeliveryRejectReason: '',
      showConfirmationModal: false,
      confirmationType: '',
      preventApiCallOnInitialStatusSelect: true
    };
    this.componentKey = 'CE_TASKBOARD';
    this.tableActionFunctions = {
      approveTask: rowData => {
        this.setState({ rowButtonDisabledById: rowData.id }, () => {
          this.changeTaskStatus(rowData, deliveryTypeStatusMap.APPROVED, () => {
            this.setState({ rowButtonDisabledById: -1 });
          });
        });
      },
      rejectTask: rowData => {
        this.setState({ rowButtonDisabledById: rowData.id }, () => {
          this.changeTaskStatus(rowData, deliveryTypeStatusMap.REJECTED, () => {
            this.setState({ rowButtonDisabledById: -1 });
          });
        });
      },
      openDaccModal: rowData => this.openDaccModal(rowData),
      openScheduleModal: (rowData, type) =>
        this.openCreateNewTaskModal(rowData, type),
      getPoDetailsAndOpenModal: rowData =>
        this.getPoDetailsAndOpenModal(rowData),
      disableRowButtons: () => {
        return this.state.rowButtonDisabledById;
      },
      approveHolidayDelivery: rowData => {
        if (rowData && rowData.cnote) {
          this.setState({ rowButtonDisabledById: rowData.cnote }, () => {
            this.props.approveHolidayDeliveryRequest(rowData.cnote, () => {
              this.setState({ rowButtonDisabledById: -1 });
            });
          });
        }
      },
      rejectHolidayDelivery: data => {
        if (data && data.cnote) {
          this.setState({ rowButtonDisabledById: data.cnote }, () => {
            this.closeRejectHolidayDeliveryModal();
            this.props.rejectHolidayDeliveryRequest(data, () => {
              this.setState({
                rowButtonDisabledById: -1,
                holidayDeliveryRejectReason: ''
              });
            });
          });
        }
      },
      openRejectHolidayDeliveryModal: rowData =>
        this.openRejectHolidayDeliveryModal(rowData),
      onRowSelect: rowData => {
        this.onRowSelect(rowData);
      },
      onAllRowSelect: () => {
        this.onAllRowSelect();
      }
    };
    this.closeDaccModal = this.closeDaccModal.bind(this);
    this.closeCreateNewTaskModal = this.closeCreateNewTaskModal.bind(this);
    this.closeBulkUploadModal = this.closeBulkUploadModal.bind(this);
    this.closePoDetailsModal = this.closePoDetailsModal.bind(this);
    this.onSearchKeyPress = this.onSearchKeyPress.bind(this);
    this.statusListNameValStrings = { nameKey: 'key', valKey: 'val' };
    this.setHolidayDeliveryRejectReason = this.setHolidayDeliveryRejectReason.bind(
      this
    );
    this.closeRejectHolidayDeliveryModal = this.closeRejectHolidayDeliveryModal.bind(
      this
    );
    this.onRowSelect = this.onRowSelect.bind(this);
    this.onAllRowSelect = this.onAllRowSelect.bind(this);
    this.isOutsideRangeCheck = this.isOutsideRangeCheck.bind(this);
  }

  componentWillMount() {
    this.props.setPageName(pageObj);
  }

  componentDidMount() {
    this.props.updateConsignmentAppointmentData();
  }

  componentWillReceiveProps() {
    const { ceTaskboardState } = this.props;

    if (
      ceTaskboardState &&
      ceTaskboardState.filters &&
      ceTaskboardState.filters.deliveryType === 'HOLIDAY_DELIVERY'
    ) {
      this.componentKey = 'CE_TASKBOARD_HOLIDAY';
    } else {
      this.componentKey = 'CE_TASKBOARD';
    }
  }

  onSearchKeyPress(event) {
    if (event.key === 'Enter') {
      this.props.getTaskboardData();
    }
  }

  getTabViewWithCount() {
    const { pendingTaskCount } = this.props.ceTaskboardState;
    return tabViewList.map(tabView =>
      Object.assign(tabView, {
        count:
          pendingTaskCount[tabView.key] && pendingTaskCount[tabView.key].count
            ? `(${pendingTaskCount[tabView.key].count})`
            : 0
      })
    );
  }

  getPoDetailsAndOpenModal(consignmentId) {
    this.setState({ isPoDetailsModalVisible: true }, () => {
      this.props.getPoDetailsByConsignmentId(consignmentId);
    });
  }

  openCreateNewTaskModal(rowData, type = null) {
    if (type !== 'create') {
      if (rowData) {
        getConsignmentAppointmentDetails(rowData.cnote, data => {
          this.setState({
            isCreateNewTaskModalVisible: true,
            selectedRowData: data
          });
        });
        this.props.getPoDetailsByConsignmentId(rowData.id);
      }
    } else {
      this.setState(
        {
          isCreateNewTaskModalVisible: true,
          selectedRowData: rowData
        },
        () => {
          if (rowData) {
            this.props.getPoDetailsByConsignmentId(rowData.id);
          }
        }
      );
    }
  }

  openBulkUploadModal() {
    this.setState({
      isBulkUploadModalVisible: true
    });
  }

  openDaccModal(rowData) {
    this.setState({ isDaccModalVisible: true, selectedRowData: rowData });
  }

  changeTaskStatus(rowData, status, cb) {
    this.props.changeTaskStatus(rowData, status, cb);
  }

  disableRowButtons(rowData) {
    this.props.disableRowButtons(rowData);
  }

  closeDaccModal() {
    this.setState({ isDaccModalVisible: false, selectedRowData: {} });
  }

  closeCreateNewTaskModal() {
    this.setState({ isCreateNewTaskModalVisible: false, selectedRowData: {} });
  }

  closeBulkUploadModal() {
    this.setState({ isBulkUploadModalVisible: false });
  }

  closePoDetailsModal() {
    this.setState({ isPoDetailsModalVisible: false });
  }

  openRejectHolidayDeliveryModal(rowData) {
    this.setState({
      isRejectHolidayDeliveryModalVisible: true,
      selectedRowData: rowData
    });
  }

  closeRejectHolidayDeliveryModal() {
    this.setState({
      isRejectHolidayDeliveryModalVisible: false,
      selectedRowData: {},
      holidayDeliveryRejectReason: ''
    });
  }

  setHolidayDeliveryRejectReason = reason => {
    this.setState({ holidayDeliveryRejectReason: reason });
  };

  openDownloadReportModal = () => {
    this.setState({ isDownloadReportModalVisible: true });
  };

  closeDownloadReportModal = () => {
    this.setState({ isDownloadReportModalVisible: false });
  };

  handleDownloadReport = (startDate, endDate) => {
    this.props.downloadStatusReport(startDate, endDate);
    this.closeDownloadReportModal();
  };

  handleFilterChange(key, val, doNotSendApicall = false) {
    this.props.updateFilter(key, val);
    if (doNotSendApicall) {
      return;
    }
    this.props.getTaskboardData();
    this.props.getConsignmentAppointmentSummary();
  }

  onRowSelect = row => {
    const newTableData = [...this.props.ceTaskboardState.taskboardData];
    const indx = newTableData.findIndex(ele => {
      return ele.id === row.id;
    });
    if (indx !== -1) {
      newTableData[indx].isSelected = !newTableData[indx].isSelected;
    }
    this.props.updateTaskBoardTable(newTableData);
  };

  onAllRowSelect = () => {
    const rows = this.props.ceTaskboardState.taskboardData;
    const isAllSelected = areAllRowsSelected(rows);

    const newTableData = [...this.props.ceTaskboardState.taskboardData];

    newTableData.forEach(row => {
      row.isSelected = isAllSelected ? false : true;
    });
    this.props.updateTaskBoardTable(newTableData);
  };

  renderTable() {
    return (
      <div>
        <ZoomTable
          configKey={this.componentKey}
          tableData={
            (this.props.ceTaskboardState.taskboardData &&
              this.props.ceTaskboardState.taskboardData) ||
            []
          }
          tableDataLength={
            (this.props.ceTaskboardState.taskboardData &&
              this.props.ceTaskboardState.taskboardData.length) ||
            0
          }
          loading={this.props.ceTaskboardState.isLoading}
          paginationProps={{
            showPagination: true,
            pageSize:
              this.props.ceTaskboardState.taskboardData &&
              this.props.ceTaskboardState.taskboardData.length
                ? this.props.ceTaskboardState.pageSize
                : 0,
            serverSidePagination: true,
            pages: Math.ceil(
              this.props.ceTaskboardState.totalElements /
                this.props.ceTaskboardState.pageSize
            ),
            onFetchData: tableState => {
              if (this.props.ceTaskboardState.pageNumber !== tableState.page) {
                this.props.updatePageNumber(tableState.page);
                this.props.getTaskboardData();
              }
            }
          }}
          actionFunctions={this.tableActionFunctions}
          disableRowActionButtons={
            this.props.ceTaskboardState.isRowActionButtonClicked
          }
        />
      </div>
    );
  }

  renderClientFilter() {
    return (
      <ClientSearch
        onSelect={(_, obj) => {
          this.handleFilterChange('client', obj);
        }}
        showAllOption
        disableNone
      />
    );
  }

  onCustomFilterDateChange(start, end) {
    if (start && end) {
      this.handleFilterChange('dateFilters', {
        fromDate: start,
        toDate: end
      });
    }
  }

  isOutsideRangeCheck(day, focusedInput, startDate) {
    const { userProfileState } = this.props;
    const { sessionProperties } = userProfileState;
    const { CETASKBOARD_DATE_FILTER_WINDOW_LENGTH } = sessionProperties;
    const fixedWindowSize =
      parseInt(CETASKBOARD_DATE_FILTER_WINDOW_LENGTH, 10) - 1;
    if (focusedInput && focusedInput === 'endDate') {
      return (
        day.isAfter(moment()) ||
        day.isBefore(moment(startDate).subtract(1, 'days')) ||
        day.isAfter(moment(startDate).add(fixedWindowSize, 'days'))
      );
    } else {
      return day.isAfter(moment());
    }
  }

  renderDateFilter() {
    const { userProfileState } = this.props;
    const { sessionProperties } = userProfileState;
    const { CETASKBOARD_DATE_FILTER_WINDOW_LENGTH } = sessionProperties;
    const fixedWindowSize =
      parseInt(CETASKBOARD_DATE_FILTER_WINDOW_LENGTH, 10) - 1;
    console.log(userProfileState);
    return (
      <div style={{ marginLeft: '10px' }}>
        <DateRangeFilter
          minusDays={fixedWindowSize}
          setDateFilter={(start, end) =>
            this.onCustomFilterDateChange(start, end)
          }
          displayFormat="DD MMM YY"
          preventSetDateByDefault={false}
          isOutsideRangeCheck={true}
          isOutsideRangeCheckFunction={this.isOutsideRangeCheck}
          hideClearDate={true}
        />
      </div>
    );
  }

  renderStatusFilter() {
    return (
      <div className="zt-filter-component-wrapper">
        <Select
          label="Status"
          optionsArrOfObj={deliveryTypeFilterStatusList}
          selectedOpt={initialStatusFilterValue}
          onSelect={(_, obj) => {
            this.handleFilterChange(
              'statuses',
              [obj.val],
              this.state.preventApiCallOnInitialStatusSelect ? true : false
            );
            if (this.state.preventApiCallOnInitialStatusSelect) {
              this.setState({
                preventApiCallOnInitialStatusSelect: false
              });
            }
          }}
          disableNone={true}
          enableSearch={false}
          nameValStrings={this.statusListNameValStrings}
        />
      </div>
    );
  }

  renderToBeScheduledCheckboxBox() {
    return (
      <div
        className={`zt-filter-component-wrapper ${styles.checkBox} l-row a-center`}
        style={{ whiteSpace: 'nowrap' }}
      >
        <input
          type="checkbox"
          name="to_be_scheduled"
          value={this.props.ceTaskboardState.filters.toBeScheduled}
          checked={this.props.ceTaskboardState.filters.toBeScheduled}
          onChange={event =>
            this.handleFilterChange('toBeScheduled', event.target.checked)
          }
        />
        <div className={styles.label}>To be scheduled</div>
        <div
          className={styles.downloadIcon}
          onClick={this.openDownloadReportModal}
          title="Download Report"
          style={{ marginLeft: '3rem', position: 'relative', top: '-1px' }}
        >
          <img
            src={require('../../../assets/images/download-theme.svg')}
            alt="Download"
            style={{
              width: '12px',
              height: '12px',
              filter: 'grayscale(100%) brightness(0.3)',
              opacity: 0.6
            }}
          />
          <span
            className={styles.reportLabel}
            style={{
              fontSize: '1.4rem',
              color: '#000',
              marginLeft: '0.5rem',
              opacity: 0.6,
              paddingBottom: '2px'
            }}
          >
            blinkit-ad-report
          </span>
        </div>
      </div>
    );
  }

  renderSearchBox() {
    return (
      <div className="zt-filter-component-wrapper">
        <SearchBox
          onSearchValueChange={val => {
            if (val) {
              val = val.trim();
            }
            this.props.updateFilter('searchString', val);
          }}
          onKeyPress={this.onSearchKeyPress}
        />
      </div>
    );
  }

  renderFilterPanel() {
    return (
      <div className="zt-filter-panel-parent l-row a-center">
        <div className="zt-filter-panel-left l-row flex-70">
          <div className="zt-filter-label l-row a-center">Filter By:</div>
          {this.renderClientFilter()}
          {this.renderStatusFilter()}
          {this.renderDateFilter()}
          {isAppointmentDelivery(
            this.props.ceTaskboardState.filters.deliveryType
          ) && this.renderToBeScheduledCheckboxBox()}
        </div>
        <div className="zt-filter-panel-right l-row flex-30 j-end">
          {this.renderSearchBox()}
        </div>
      </div>
    );
  }

  renderTabView() {
    const tabViewDataList = this.getTabViewWithCount();
    return (
      <div className="flex-60">
        <TabView
          data={tabViewDataList}
          selectedTab={
            this.props.ceTaskboardState.filters.deliveryType &&
            tabViewDataList.findIndex(
              tabViewData =>
                tabViewData.key ===
                this.props.ceTaskboardState.filters.deliveryType
            )
          }
          onTabSelect={val => {
            this.handleFilterChange('deliveryType', tabViewDataList[val].key);
          }}
          tabViewContainerClassName="deliveryTypeTabView "
          tabClassName="deliveryTypeTabs"
          selectedTabClassName="deliveryTypeSelectedTab"
          tabCountClassName="deliveryTypeTabCount"
          tabNameClassName="deliveryTypeTabName"
        />
      </div>
    );
  }

  closeConfirmationModal = () => {
    this.setState({
      showConfirmationModal: false
    });
  };

  confirmHandler = () => {
    const dataToSend = [];

    const rows =
      this.props.ceTaskboardState && this.props.ceTaskboardState.taskboardData;

    (rows || []).forEach(row => {
      if (row.isSelected) {
        dataToSend.push({
          id: row.appointmentRecordId,
          status:
            this.state.confirmationType === 'Approve'
              ? deliveryTypeStatusMap.APPROVED
              : deliveryTypeStatusMap.REJECTED,
          consignmentId: row.id,
          deliveryType: row.deliveryType
        });
      }
    });

    if (dataToSend.length < 2) {
      toastr.error('Error', 'Please select at least 2 consignments');
      return;
    }

    this.props.bulkApproveOrReject(dataToSend, this.closeConfirmationModal);
  };

  bulkApproveOrRejectHandler = approve => {
    this.setState({
      showConfirmationModal: true,
      confirmationType: approve ? 'Approve' : 'Reject'
    });
  };

  renderCommonActions() {
    return (
      <div className="flex-40 l-row j-end a-center a-end">
        <Select
          styles={{ marginRight: '10px' }}
          label="Select Bulk Actions"
          selectedOpt={''}
          optionsArrOfObj={bulkActionsDropdown || []}
          onSelect={val => {
            this.bulkApproveOrRejectHandler(val === 'Approve' ? true : false);
          }}
          disabled={false}
          disableNone={true}
          selectedWrapperClass="white-background"
        />
        <div
          className={`${styles.secondaryBtnWrapper} ${styles.big} l-row j-center a-center`}
          onClick={() => this.openBulkUploadModal()}
        >
          Bulk Upload Appointment
        </div>
        <div
          className={`${styles.submitBtnWrapper} ${styles.big} l-row j-center a-center`}
          onClick={() => this.openCreateNewTaskModal(null, 'create')}
        >
          Create New Task
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderFilterPanel()}
        <div className="l-row">
          {this.renderTabView()}
          {this.renderCommonActions()}
        </div>
        {this.renderTable()}
        <DaccModal
          showModal={this.state.isDaccModalVisible}
          rowData={this.state.selectedRowData}
          closeModal={this.closeDaccModal}
          markUnmarkDacc={this.props.markUnmarkDacc}
        />
        <CreateNewAppointmentTaskModal
          showModal={this.state.isCreateNewTaskModalVisible}
          rowData={{
            ...this.state.selectedRowData,
            purchaseOrderDTOs: (this.props.ceTaskboardState &&
              this.props.ceTaskboardState.poDetails &&
              this.props.ceTaskboardState.poDetails
                .deliveryClientCustomFieldsDTO &&
              this.props.ceTaskboardState.poDetails
                .deliveryClientCustomFieldsDTO.purchaseOrderDTOs) || [
              { ...defaultPODetail }
            ],
            fcName:
              this.props.ceTaskboardState &&
              this.props.ceTaskboardState.poDetails &&
              this.props.ceTaskboardState.poDetails
                .deliveryClientCustomFieldsDTO &&
              this.props.ceTaskboardState.poDetails
                .deliveryClientCustomFieldsDTO.fcName,
            fcNameHash:
              (this.props.ceTaskboardState &&
                this.props.ceTaskboardState.fcNameHash) ||
              {}
          }}
          closeModal={this.closeCreateNewTaskModal}
          scheduleTask={this.props.scheduleTask}
          getPoDetailsByConsignmentId={this.props.getPoDetailsByConsignmentId}
          isPoDetailsLoading={
            this.props.ceTaskboardState &&
            this.props.ceTaskboardState.isPoDetailsLoading
          }
          isSubmitButtonDisabled={
            this.props.ceTaskboardState &&
            this.props.ceTaskboardState.isSubmitButtonDisabled
          }
          userProfile={this.props.userProfileState}
        />
        <BulkUploadModal
          showModal={this.state.isBulkUploadModalVisible}
          closeModal={this.closeBulkUploadModal}
          bulkUploadAppointment={this.props.bulkUploadAppointment}
        />
        <RejectHolidayDeliveryRequestModal
          showModal={this.state.isRejectHolidayDeliveryModalVisible}
          rowData={this.state.selectedRowData}
          closeModal={this.closeRejectHolidayDeliveryModal}
          reason={this.state.holidayDeliveryRejectReason}
          setReason={this.setHolidayDeliveryRejectReason}
          rejectHolidayDeliveryRequest={
            this.tableActionFunctions.rejectHolidayDelivery
          }
        />
        <ModalWithTable
          showModal={this.state.isPoDetailsModalVisible}
          closeModal={this.closePoDetailsModal}
          tableKey="PO_DETAILS"
          tableData={
            (this.props.ceTaskboardState &&
              this.props.ceTaskboardState.poDetails &&
              this.props.ceTaskboardState.poDetails
                .deliveryClientCustomFieldsDTO &&
              this.props.ceTaskboardState.poDetails
                .deliveryClientCustomFieldsDTO.purchaseOrderDTOs) ||
            []
          }
          title={`FC Name: ${(this.props.ceTaskboardState &&
            this.props.ceTaskboardState.poDetails &&
            this.props.ceTaskboardState.poDetails
              .deliveryClientCustomFieldsDTO &&
            this.props.ceTaskboardState.poDetails.deliveryClientCustomFieldsDTO
              .fcName) ||
            '--'}`}
          modalTheme={{ name: 'themeGrey' }}
          loading={
            this.props.ceTaskboardState &&
            this.props.ceTaskboardState.isPoDetailsLoading
          }
        />
        {this.state.showConfirmationModal ? (
          <ConfirmationModal
            showLoader={
              this.props.ceTaskboardState.bulkApproveOrRejectInProgress
            }
            minWidth="40%"
            showModal={true}
            title="Confirmation"
            closeModal={this.closeConfirmationModal}
            confirm={this.confirmHandler}
            reject={this.closeConfirmationModal}
            heading={`Are You sure you want to ${this.state.confirmationType}  ? `}
          />
        ) : null}
        <DownloadReportModal
          showModal={this.state.isDownloadReportModalVisible}
          closeModal={this.closeDownloadReportModal}
          onDownload={this.handleDownloadReport}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ceTaskboardState: state.ceTaskboardState,
  initServiceState: state.initServiceState,
  userProfileState: state.userProfile
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getTaskboardData: bindActionCreators(getTaskboardData, dispatch),
  updatePageNumber: bindActionCreators(updatePageNumber, dispatch),
  changeTaskStatus: bindActionCreators(changeTaskStatus, dispatch),
  markUnmarkDacc: bindActionCreators(markUnmarkDacc, dispatch),
  scheduleTask: bindActionCreators(scheduleTask, dispatch),
  updateConsignmentAppointmentData: bindActionCreators(
    updateConsignmentAppointmentData,
    dispatch
  ),
  updateFilter: bindActionCreators(updateFilter, dispatch),
  bulkUploadAppointment: bindActionCreators(bulkUploadAppointment, dispatch),
  getPoDetailsByConsignmentId: bindActionCreators(
    getPoDetailsByConsignmentId,
    dispatch
  ),
  getFcNameHash: bindActionCreators(getFcNameHash, dispatch),
  approveHolidayDeliveryRequest: bindActionCreators(
    approveHolidayDeliveryRequest,
    dispatch
  ),
  rejectHolidayDeliveryRequest: bindActionCreators(
    rejectHolidayDeliveryRequest,
    dispatch
  ),
  updateTaskBoardTable: data => dispatch(updateTaskBoardTable(data)),
  bulkApproveOrReject: bindActionCreators(bulkApproveOrReject, dispatch),
  getConsignmentAppointmentSummary: bindActionCreators(
    getConsignmentAppointmentSummary,
    dispatch
  ),
  downloadStatusReport: bindActionCreators(downloadStatusReport, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CETaskboard);
